<template lang="pug">
#fonte
    el-collapse.mx-2
        el-collapse-item
            p(slot='title') {{ $t('mensagens.diagnosticoSocioambiental.fonteDosDados') }}

            p.mb-2 {{ $t('mensagens.diagnosticoSocioambiental.dataDeCadastro') }}: {{ fonte.dataCadastro || '-' }}
            p.mb-2.fonte-item(v-for='(item, index) in itens', :key='index')
                | {{ item.nome || '-' }} -
                a(style='word-break: break-word;'
                :href='item.url', target='_blank') {{ ' ' + (item.url || '-') }}
</template>

<script>
export default {
    name: 'Fonte',

    data() {
        return {
            itens: []
        };
    },

    props: {
        fonte: {
            type: Object,
            required: true
        }
    },
    watch: {
        fonte: function () {
            this.listarFontes();
        }
    },
    mounted() {
        this.listarFontes();
    },
    methods: {
        listarFontes() {
            const nomes = (this.fonte.nome || '').split('|').map(nome => nome.trim());
            const urls = (this.fonte.url || '').split('||').map(url => url.trim());
            const tamanho = Math.max(nomes.length, urls.length);

            this.itens = Array.from({ length: tamanho }, (_, index) => ({
                nome: nomes[index],
                url: urls[index]
            }));
        }
    }
};
</script>

<style lang="scss">
#fonte {
    margin-left: 13px;

    .el-icon-arrow-right {
        margin-top: -13px;
        margin-left: 5px;
    }

    .el-collapse-item__wrap {
        border: none;
    }

    .el-collapse-item__header {
        border-bottom: none;
    }

    p {
        line-height: 1;
    }
}
</style>
